<template>
  <SGPModalComponent
    tamanho="lg"
    titulo="Regras"
    v-if="mostrarModal"
    @sgpModalFechar="$emit('fecharModalExpressoesLogicas', true)"
  >
    <div>
      <SGPAlertaComponent v-if="!campoAtual.expressoes_logicas.length">
        Não existem regras cadastradas para este campo
      </SGPAlertaComponent>
      <div
        class="expressao d-flex mb-2"
        v-for="(expressao, index) in campoAtual.expressoes_logicas"
        :key="expressao"
      >
        <SGPFormAutocompleteComponent
          :listaDeOptions="camposHabilidados"
          optionLabel="label"
          optionValue="id"
          solo
          placeholderText="Tipo do campo"
          style="width: 100%;"
          mostrarSelecione
          v-model="expressao.ctrl_campo_id"
        />

        <SGPFormAutocompleteComponent
          :listaDeOptions="listaDeExpressoes"
          optionLabel="expressao"
          optionValue="id"
          v-model="expressao.ctrl_expressao_booleana_id"
          solo
          placeholderText="Tipo do campo"
          style="width: 100%;"
          class="ml-2 mr-2"
          mostrarSelecione
        />

        <SGPFormInputComponent            
          solo
          placeholderText="Tipo do campo"
          style="width: 100%;"
          mostrarSelecione
          placeholder="Valor"
          v-model="expressao.verificador"
        />

        <SGPFormBotaoComponent
          class="ml-2"
          small
          fab
          text
          @click="removerRegra(index)"
        >
          <SGPIconComponent>mdi-delete</SGPIconComponent>
        </SGPFormBotaoComponent>
      </div>

      <div class="text-center mt-5">
      <SGPFormBotaoComponent small fab class="text-capitalize text-center" @click="adicionarRegra">
        <SGPIconComponent>mdi-plus</SGPIconComponent>
      </SGPFormBotaoComponent>
      </div>
    </div>
  </SGPModalComponent>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js'

export default {
  name: 'CamposExpressoesComponent',

  props: {
    campoAtual: {
      type: Object,
      required: true
    },

    formulario: {
      type: Object,
      required: true
    },

    mostrarModal: {
      type: Boolean,
      required: true
    }
  },

  mounted () {
    console.log('Esse aqui éo id do campo: ', this.campoAtual.ctrl_campo_id)
  },

  computed: {
    ...mapGetters('ctrlFormularioDinamico', [
      'listaDeExpressoesBooleanas'
    ]),

    camposHabilidados() {
      let campos = []
      this.formulario.map(row => {
        row.campos.map(campo => {
          if(campo.ctrl_campo_id != this.campoAtual.ctrl_campo_id) {
            campos.push(campo.ctrl_campo)
          }
          return campo
        })
        return row
      })
      return campos
    },

    listaDeExpressoes () {
      if (this.listaDeExpressoesBooleanas) {
        return this.listaDeExpressoesBooleanas
      }
      return []
    }
  },

  methods: {
    adicionarRegra() {
      this.campoAtual.expressoes_logicas.push({
        ctrl_expressao_id: null,
        ctrl_campo_id: null,
        verificador: ''
      })
    },

    removerRegra(index) {
      this.campoAtual.expressoes_logicas.splice(index, 1)
    },

    fecharModalExpressoesLogicas () {
      this.mostrarModalExpressoesLogicas = false
      this.campoSelecionado = null
    }
  }
}
</script>